module.exports = __webpack_public_path__ + "static/media/python.f9eec3d2.svg";